export default {
  'movementWorkOrdersReport.form.selectReportType': 'Select report type',
  'movementWorkOrdersReport.form.selectReportType.totalPerBudget':
    'Total per budget',
  'movementWorkOrdersReport.form.selectReportType.insurerAndPrivate':
    'Insurer/Private',
  'movementWorkOrdersReport.form.selectReportType.estimators': 'Estimators',
  'movementWorkOrdersReport.form.selectReportType.ServicesAndPartsPerVehicle':
    'Services/Parts per vehicle',
  'movementWorkOrdersReport.form.selectReportType.osCost': 'OS cost',
  'movementWorkOrdersReport.form.selectReportType.partStatus': 'Part Status',
  'movementWorkOrdersReport.form.selectReportType.osByArea': 'OS by area',

  'movementWorkOrdersReport.form.filterByDate': 'Filter by date',
  'movementWorkOrdersReport.form.filterByDate.entrance': 'Entrance',
  'movementWorkOrdersReport.form.filterByDate.authorization': 'Authorization',
  'movementWorkOrdersReport.form.filterByDate.shutdown': 'Shutdown',
  'movementWorkOrdersReport.form.filterByDate.expectedDeparture':
    'Expected departure',
  'movementWorkOrdersReport.form.filterByDate.delivery': 'Delivery',

  'movementWorkOrdersReport.form.situation': 'Situation',
  'movementWorkOrdersReport.form.situation.open': 'Open',
  'movementWorkOrdersReport.form.situation.authorized': 'Authorized',
  'movementWorkOrdersReport.form.situation.closed': 'Closed',
  'movementWorkOrdersReport.form.situation.canceled': 'Canceled',

  'movementWorkOrdersReport.form.budgetType': 'Budget Type',
  'movementWorkOrdersReport.form.budgetType.budget': 'Budget',
  'movementWorkOrdersReport.form.budgetType.assurance': 'Assurance',
  'movementWorkOrdersReport.form.budgetType.return': 'Return',
  'movementWorkOrdersReport.form.budgetType.courtesy': 'Courtesy',
  'movementWorkOrdersReport.form.budgetType.insideCourtesy':
    'Inside (Courtesy)',
  'movementWorkOrdersReport.form.budgetType.totalLoss': 'Total loss',
  'movementWorkOrdersReport.form.budgetType.revision': 'Revision',

  'movementWorkOrdersReport.form.synthetic': 'Synthetic?',
  'movementWorkOrdersReport.form.particular': 'Particular?',

  'movementWorkOrdersReport.form.moreOptions': 'More options',
  'movementWorkOrdersReport.form.moreOptions.estimators': 'Estimators',
  'movementWorkOrdersReport.form.moreOptions.button.selectCustomers':
    'Select Customers',
  'movementWorkOrdersReport.form.moreOptions.button.selectVehicles':
    'Select Vehicles',
  'movementWorkOrdersReport.form.moreOptions.button.selectBrands':
    'Select Brands',
  'movementWorkOrdersReport.form.moreOptions.button.selectModels':
    'Select Models',

  'movementWorkOrdersReport.form.checkbox.parts': 'Parts',
  'movementWorkOrdersReport.form.checkbox.partsProvided': 'Parts Provided',
  'movementWorkOrdersReport.form.checkbox.tasks': 'Tasks',
  'movementWorkOrdersReport.form.checkbox.third': 'The 3rd',
  'movementWorkOrdersReport.form.checkbox.benefits': 'Benefits',
  'movementWorkOrdersReport.form.filterServiceAndPartDescription':
    'Filter by service/part description:',
};
